<app-career-header-banner></app-career-header-banner>
<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center">
  <span class="font-bold text-3xl website-heading">Diverse culture where curious minds collaborate</span>
</div>

<div class="w-full flex flex-col items-center justify-center gap-8 mt-10">

  <div class="flex items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <div>
      <div class="flex flex-col items-start justify-start gap-4 mt-4">
        <h3 class="text-xl font-bold ">Jr. QA Engineer</h3>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/experience.png" alt="" class="size-5">
          <p class="text-black text-sm">2+ years</p>
        </div>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/job-location.png" alt="" class="size-5">
          <p class="text-black text-sm">Varroc Connect, Pune</p>
        </div>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/employment-type.png" alt="" class="size-5">
          <p class="text-black text-sm">Full Time</p>
        </div>
      </div>

    </div>
  </div>

  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="text-sm"><strong>About Us : </strong> Varroc Connect is a leader in the automotive technology space,
      dedicated to delivering innovative connected vehicle solutions that enhance safety and user experience. We are
      passionate about quality and are looking for motivated individuals to join our team and contribute to our
      mission.</span>
  </div>

  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="text-sm"><strong>Position Overview : </strong> We are seeking a detail-oriented and enthusiastic Junior
      QA Engineer to join our quality assurance team. The ideal candidate will assist in the testing process to ensure
      the delivery of high-quality software products. This is a great opportunity for someone looking to start their
      career in quality assurance and gain hands-on experience in a fast-paced environment.</span>
  </div>

  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <div>
      <span class="font-bold text-sm">Key Responsibilities:</span>
      <div class="mb-4 mt-2">
        <p class="font-bold text-sm">1. Test Case Development:</p>
        <ul class="pl-4">
          <li class="text-sm">a. Assist in the creation and execution of test cases based on software requirements and
            specifications.</li>
          <li class="text-sm">b. Maintain test documentation and track testing progress.</li>
        </ul>
      </div>

      <div class="mb-4">
        <p class="font-bold text-sm">2. Manual Testing:</p>
        <ul class="pl-4">
          <li class="text-sm">a. Perform manual testing of applications across various platforms and environments.</li>
          <li class="text-sm">b. Execute functional, regression, and user acceptance tests to identify defects.</li>
        </ul>
      </div>

      <div class="mb-4">
        <p class="font-bold text-sm">3. Defect Reporting:</p>
        <ul class="pl-4">
          <li class="text-sm">a. Identify, document, and track defects using bug tracking tools.</li>
          <li class="text-sm">b. Collaborate with the development team to communicate issues and assist in their
            resolution.</li>
        </ul>
      </div>

      <div class="mb-4">
        <p class="font-bold text-sm">4. Automation Support:</p>
        <ul class="pl-4">
          <li class="text-sm">a. Support the QA team in developing and maintaining automated test scripts.</li>
          <li class="text-sm">b. Learn and utilize automation tools under the guidance of senior team members.</li>
        </ul>
      </div>

      <div class="mb-4">
        <p class="font-bold text-sm">5. Continuous Learning:</p>
        <ul class="pl-4">
          <li class="text-sm">a. Stay updated with the latest trends and best practices in software testing and quality
            assurance.</li>
          <li class="text-sm">b. Participate in team meetings and contribute to discussions on quality improvement
            initiatives.</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Qualifications :</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm" *ngFor="let skill of skills">
        {{skill}}
      </li>
    </ul>
  </div>

  <app-career-form-submission class="px-5 w-5/6 md:w-3/4" [jobDescription]="selectedJob"></app-career-form-submission>
</div>